fx.ns("desktop.player", class BookPreview extends fx.Component
{
	constructor(data)
	{
		super(data);

		this._index = 0;
		this._notifDelay = 5000;
	}

	get book()
	{
		return this.data.creation;
	}

	get currentArea()
	{
		return this.area;
	}

	get coverLabel()
	{
		return this.book.coverName;
	}
	
	getArea(id)
	{
		return this.area;
	}

	// --------------------------- RENDER --------------------------- //

	create()
	{
		super.create();

        this.mobileNotifButton = new fx.components.Text({text : fx.text("Appuyez ici pour tourner les pages"), className:"mobileNotifButton"});

		this.area = new desktop.player.BookPreviewArea(this.book.cover, this.data, this, "right", true);
		this.area.hideLabels = true;
		this.addChild(this.area, {height:this.book.coverHeight});

		if(fx.browser.isMobile)
			this.addChild(this.mobileNotifButton, {top :"50%", left : 0, width: "90%"});
    }

	show(callback){
        super.show(callback);
	}

	onReady()
	{
		this.area.setParentSize(this.realWidth, this.realHeight);
		this.delay(this._hideMobileNotifButton, this._notifDelay);

		

		if(fx.browser.isDesktop)
            this.on("click", this._onAreaClick, this.area);
        else
		{
			this.on("tap", this._onTap, this.area);
			this.on("swipe", this._onSwipe, this.area);
		}
        
		this.on("fullscreenchange", this._onFullScreenChange, window);
		this.on('mozfullscreenchange', this._onFullScreenChange, window);
        this.on('webkitfullscreenchange', this._onFullScreenChange, window);
        this.on('msfullscreenchange', this._onFullScreenChange, window);

        this.on("fullscreen", this.onFullScreen, this.area);

		this.updatePage();
	}

    onFullScreen()
    {
        this.addClass("hidden");
        this.delay(this._setFullScreen, 250);
    }

    _setFullScreen()
    {
        fx.graphics.fullScreen(this);   
    }
    

	_onTap(){
		this._hideMobileNotifButton();
	}

	_onSwipe(){
		this._hideMobileNotifButton();
	}

	_onAreaClick()
	{
		this.area.setParentSize(this.realWidth, this.realHeight);
		this.trigger("select");
	}

	updatePage()
	{
		if(this.mobileNotifButton)
			this.mobileNotifButton.viewport({top :(this.realHeight/2)-(this.mobileNotifButton.realHeight/2), left : (this.realWidth/2)-(this.mobileNotifButton.realWidth/2)+20, width: "90%"}); // 20px added to left = button padding

		let page = (this._index == this.book.pages.length) ? this.book.cover : this.book.pages.getItemAt(this._index);
		this.area.displayedSide = page.isCover ? (this._index == 0 ? "right" : "left") : "";
		this.updateDisplay();
		this.area.load();

		if (page.isCover)
			this.area.activePart = "";
	}

    _hideMobileNotifButton(){
        this.mobileNotifButton.hide();
    }

	_onFullScreenChange()
    {
        if(!document.webkitIsFullScreen)
        {
            this.removeClass("fullscreen");
            this.addClass("hidden");
        }
        
        this.delay(this._updateView, 250);
    }

    _updateView()
    {
		this.updateDisplay();
		this.area.setParentSize(this.realWidth, this.realHeight);
    	
        if (document.webkitIsFullScreen)
            this.addClass("fullscreen");
       
        this.removeClass("hidden");
	}


	destroy()
	{
		super.destroy();
		this.area.destroy();
	}


});